import React from 'react';
import LandingPage from './LandingPage';  // Import LandingPage.jsx

function App() {
  return (
    <div className="App">
      <LandingPage />  {/* Render LandingPage component */}
    </div>
  );
}

export default App;
